var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 23,
    viewBox: "0 0 40 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-4 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(4 14)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 23,
    rx: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 21,
    rx: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(9 18)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.321c542dc6653cd25af9745970c20d25.svg";
export { ForwardRef as ReactComponent };